<template>
  <fragment>
    <PlayerNotFetched />
  </fragment>
</template>

<script>
import PlayerNotFetched from "../components/PlayerNotFetched";

export default {
  name: "home",
  components: {
    PlayerNotFetched
  }
};
</script>
